export default __webpack_public_path__ + "static/media/main_road_1.ad8b76da.jpg";